/* eslint-disable react/prop-types */
import React from "react";

const CheckboxInput = ({
  name,
  value,
  checked,
  onChange,
  label,
  className = "",
  labelClassName = "",
}) => {
  return (
    <label className={`flex items-center space-x-1 ${labelClassName}`} htmlFor={name}>
      <input
        type="checkbox"
        name={name}
        id={name}
        value={value}
        checked={checked}
        onChange={onChange}
        className={`form-checkbox ${className}`}
      />
      <span>{label}</span>
    </label>
  );
};

export default CheckboxInput;